export function ReferralsTable({ referrals }) {
  return (
    <div className="bg-white border border-black p-6">
      <h3 className="text-lg font-bold mb-4">Recent Referrals</h3>
      {referrals?.length > 0 ? (
        <div className="space-y-3">
          {referrals.map((ref) => (
            <div
              key={`${ref.name}-${ref.created_at}`}
              className="flex items-center justify-between border-b border-gray-100 pb-3"
              data-testid="referral-item"
            >
              <div>
                <p className="font-medium">{ref.name}</p>
                <p className="text-sm text-gray-500">{new Date(ref.created_at).toLocaleDateString()}</p>
              </div>
              <span
                className={`px-2 py-1 text-xs font-bold ${
                  ref.subscription ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-700"
                }`}
              >
                {ref.subscription ? ref.subscription.toUpperCase() : "FREE"}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No referrals yet. Share your link to start earning!</p>
      )}
    </div>
  );
}
